import { store } from '../../../../resources/frontend/js/store/index';

export const checkWorkTypeOverride = () => {
    let overrideValue, enquiryDashboardRedirectVersion;
    const quizStore = store.state.quiz;
    const settings = quizStore.advancedWorktypeSettings;
    const answers = {};

    Object.values(quizStore.extradata).forEach((question) => {
        answers[question.uuid] = question.value;
    });

    settings.forEach((setting) => {
        const settingAnswers = {};

        setting.questions.forEach((question) => {
            const uuid = question.split('_')[0];
            const value = question.split('_')[1];

            if (!settingAnswers[uuid]) settingAnswers[uuid] = [];

            settingAnswers[uuid].push(value);
        });

        const isOverride = Object.entries(settingAnswers).every(settingAnswer => {
            return settingAnswer[1].includes(answers[settingAnswer[0]]);
        });

        if (isOverride) {
            overrideValue = setting.value;
            enquiryDashboardRedirectVersion = setting.enquiry_dashboard_redirect_version;
        }
    });

    if (overrideValue) {

        if (!store.getters['form/fieldExists']('worktype_id')) {
            store.commit('form/addField', {
                step: 0,
                name: 'worktype_id',
            });
        }

        store.commit('form/setFieldData', {name: 'worktype_id', key: 'value', value: overrideValue});
    }

    if (enquiryDashboardRedirectVersion) {
        if (!store.getters['form/fieldExists']('enquiry_dashboard_redirect_version')) {
            store.commit('form/addField', {
                step: 0,
                name: 'enquiry_dashboard_redirect_version',
            });
        }

        store.commit('form/setFieldData', {
            name: 'enquiry_dashboard_redirect_version',
            key: 'value',
            value: enquiryDashboardRedirectVersion
        });
    }
};
